module.exports = __webpack_public_path__ + "main/assets/public/footer/background-texture.94c4f9cbc2ce8104.gif";